var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.body)?_c('div',[(_vm.body.text)?_c('rich-text-renderer',{attrs:{"document":_vm.body.text}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }